<p>offers-scan-manage works!</p>
